import { atom } from "jotai";

export const visibleModalCrearSolicitudAtom = atom(false);
export const documentosSolicitadosAtom = atom([]);
export const solicitudesDocumentosAtom = atom([]);
export const loadingAtom = atom(false);
